import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DashboardV2 from '../views/DashboardV2.vue'
// import BranchOverView from '../components/BranchOverView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/dashboard',
    name: 'DashboardV2',
    component: DashboardV2
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
  },
  {
    path: '/branch',
    name: 'BranchOverView',
    // component: BranchOverView
    component: () =>
      import(/* webpackChunkName: "about" */ '../components/BranchOverView.vue')
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
  },
  {
    path: '/summary',
    name: 'Summary',
    // component: BranchOverView
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Summary.vue')
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
  },
  {
    path: '/executive-summary',
    name: 'ExecutiveSummary',
    // component: BranchOverView
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ExecutiveSummary.vue')
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/DashboardV2.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
